import { CardAnalyticsType } from '@prospectus/common/ui-strict/BaseCard/types';
import { ProductType } from '@prospectus/common/types/productTypes';

export interface QuickFactProps {
  text: string;
  icon: string;
}

export interface OwnerType {
  key?: string;
  logoImageUrl?: string;
  name?: string;
}

// We pass certain properties, position, index, queryID, as a url param into the about pages
// so that when the user interacts with the page we can alert Algolia thru an event
// These properties cannot be renamed
// https://2u-internal.atlassian.net/wiki/spaces/WS/pages/8750451/Algolia+resource+hub#Eventing-for-personalization
export interface CardUrlParamsType {
  // The search index, which we send to Algolia
  index?: 'product';
  // search query ID, which we send to Algolia
  queryID?: string;
  // The individual card's position in a block of search results, which we send to Algolia
  position?: number;
  product_line?: string;
  // Optional subcategory of product_line
  product_category?: string;
  // What organization does this card come from?
  source?: 'edx' | '2u' | 'emeritus';
  parent_component?: 'new-on-edx' | 'search-results';
  campaign?: string;
  placement_url?: string;
  plp?: boolean;
  webview?: boolean;
  partner?: string;
  page_type?: string;
  // A unique ID assigned to each user based on their device, so we can track
  // their movement around the website and beyond
  eaid?: string;
  linked_from?: string;
}

export type CourseOrProgramType = 'course' | 'program' | 'program_course';

export interface ProductCardProps {
  isLoading?: boolean;
  title: string;
  productSource?: string;
  productType: ProductType;
  path: string;
  uuid: string;
  shouldfirePreQuerySegmentEvent?: boolean,
  // additional properties, formatted as key value paris, to send with the click event on the card
  analytics?: CardAnalyticsType;
  urlParams?: CardUrlParamsType;
  schoolName: string;
  schoolLogo: string;
  headerImage?: string;
  handleOnClick?: () => void;
  hasDeviceParam?: boolean;

  lobExperimentVariation?: string;

  cardType?: CourseOrProgramType;
  courseType?: string;
  courseLength?: number;
  is2UDegreeProgram?: boolean;
  owners?: OwnerType[];

  // Footer Props
  factoid?: string;
  quickFacts?: QuickFactProps[];
  externalUrl?: string;
  footerMessageKey?: string;
  useExpandedProductCard?: boolean;
  weeksToComplete?: number;
  minPrice?: number;
  maxPrice?: number;
  courseCount?: number;
  levelType?: string;
  pacingType?: string;
  useCohesion?: boolean;
  cohesionPayload?: any;
}

export const ProductCardDefaultProps = {
  factoid: '',
  hasDeviceParam: false,
  position: undefined,
  quickFacts: [],
  isLoading: false,
  urlParams: undefined,
  eaid: undefined,
  source: undefined,
  lobExperimentVariation: '',
  headerImage: undefined,
  productSource: undefined,
  shouldfirePreQuerySegmentEvent: false,
  useExpandedProductCard: false,
  weeksToComplete: undefined,
  minPrice: undefined,
  maxPrice: undefined,
  courseCount: undefined,
  levelType: '',
  pacingType: '',
};
